// extracted by css-extract-rspack-plugin
module.exports =  {"emphasize":"SplitPayoutDialog__emphasize___EH17s"};